import { createContext } from 'react';

const LeaseAbstractionContext = createContext({
  // Flag to identify the new enhanced split-pane flow vs the legacy modal flow.
  // Defaults to false so the legacy "Import Data to Voucher" modal (file-modal.js)
  // does not receive any of the new UI elements (confidence legend, required
  // asterisks, redesigned extraction chip, extra Tenant fields, etc.).
  isEnhancedFlow: false,
  modalFieldState: {},
  modalFieldChangeHandler: () => {},
  individualModalFieldChangeHandler: () => {},
  fieldErrorMap: {},
  validateLeaseAbstractionFields: () => {},
  showPageValidation: false,
  goToPage: () => {},
  isMagnified: false,
  setPdfPageData: () => {},
  findFieldRef: () => {},
  currentHighlightedField: null,
  setCurrentHighlightedField: () => {},
  // Deal / property direct-save fields
  deal: {},
  updateDeal: () => {},
  properties: [],
  onPropertyChange: () => () => {},
  onPropertyBlur: () => () => {},
  onSpaceChange: () => () => {},
  onSpaceBlur: () => () => {},
  onCurrencyBlur: () => () => {},
  voucher: {},
  updateVoucher: () => {},
  agreementTypeData: [],
  transactionTypeData: [],
  spaceTypeData: [],
  buildingClassData: [],
  // Tenant Information accordion
  company: {},
  onCompanyChange: () => {},
  onCompanyBlur: () => {},
  tenantSearchState: { suggestions: [], showSuggestions: false, loading: false },
  onTenantSuggestionSelect: () => {},
  closeTenantSuggestions: () => {},
  triggerTenantSearch: () => {},
  tenantPartyType: 'client',
  isTenantRelocating: false,
  priorProperty: null,
  onPriorPropertyChange: () => () => {},
  onPriorPropertyBlur: () => () => {},
  onPriorPropertyCreate: () => {},
  onPriorPropertyDelete: () => {},
  onPriorSpaceChange: () => () => {},
  onPriorSpaceBlur: () => () => {},
  // Landlord Information accordion
  landlordCompany: {},
  onLandlordCompanyChange: () => {},
  onLandlordCompanyBlur: () => {},
  landlordSearchState: { suggestions: [], showSuggestions: false, loading: false },
  onLandlordSuggestionSelect: () => {},
  closeLandlordSuggestions: () => {},
  triggerLandlordSearch: () => {},
  landlordPartyType: 'counter_party',
  // Chip accept → direct DB patch helpers
  patchTenantCompany: () => {},
  patchLandlordCompany: () => {},
  patchTenantContact: () => {},
  patchLandlordContact: () => {},
  // Property search — select from EDP/ESRI, auto-fills all property fields + persists to DB
  selectPropertyFromSearch: () => {},
  // Comp data field save — dispatches updateCompData on blur for lease-comp sections
  saveCompField: () => {},
});

export default LeaseAbstractionContext;
